import React from 'react';
import { Grid, Box, Typography, Link, Tooltip } from '@mui/material';
import { Form, Spacer } from 'src/components/shared';
import InfoIcon from '@mui/icons-material/Info';

export default function HardBounceWorkflow({ tenantSettings, id, ...props }) {
  const styles = {
    container: {
      height: '80%',
    },
    infoIcon: {
      fill: 'rgba(0, 0, 0, 0.26)',
      width: 20,
      marginTop: 17,
    },
    link: {
      '&:hover': {
        color: '#1976D2',
      },
      position: 'relative',
      textDecoration: 'none',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: '0px',
        width: '100%',
        height: '1px',
        backgroundColor: '#1976D2',
      },
    },
  };

  const handleChange = async (isEnabled) => {
    await props.updateSettings({ id, isBounceWorkflowEnabled: isEnabled });
  };

  const TitleBar = ({ title, tooltip }) => {
    return (
      <Box display="flex" alignItems="center">
        <Typography variant="h4">{title}</Typography>
        {tooltip && tooltip !== '' ? (
          <>
            <Spacer y={1} x={0.5} />
            <Tooltip title={tooltip}>
              <InfoIcon style={styles.infoIcon} />
            </Tooltip>
          </>
        ) : null}
      </Box>
    );
  };

  return (
    <Form
      initialValues={{
        isBounceWorkflowEnabled: tenantSettings.isBounceWorkflowEnabled || false,
      }}
      enableReinitialize={true}
    >
      <Box style={styles.container}>
        <Grid display="flex" flexDirection="column" container mt={-0.5}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                This is a paid service, and charges apply for usage.{' '}
                <Link
                  component="button"
                  type="button"
                  onClick={() => window.open('/admin/billing/subscriptions', '_blank')}
                  underline="none"
                  color="#1976D2"
                  sx={styles.link}
                >
                  Add Funds
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid spacing={2} display="flex" ml={1.5} mt={1}>
            <Form.Field.Switch
              name="isBounceWorkflowEnabled"
              onChange={handleChange}
              label={'when a hard bounce occurs in sequence'}
            />
            <TitleBar tooltip="When enabled, SuperReach will automatically find a valid replacement email address when a hard bounce occurs. This is a paid service, and charges apply for usage." />
          </Grid>
        </Grid>
      </Box>
    </Form>
  );
}
